export var SelfAssignMapper = function (params) {
    var assignEntity = {
        response: "",
        responseDescription: "",
        success: false,
        leadId: "",
        taskId: "",
        exist: "",
    };
    if (params) {
        assignEntity.success = params.success;
        if (params.data) {
            assignEntity.taskId = params.data.taskId;
            assignEntity.exist = params.data.exist;
            assignEntity.response = params.data.response;
            assignEntity.responseDescription = params.data.responseDescription;
            assignEntity.leadId = params.data.leadId;
        }
    }
    return assignEntity;
};
